import React, { useState } from 'react';
import { Badge, Button, Card, Dropdown, Flex, Select, Space } from 'antd';
import { FilterOutlined, FilterFilled } from '@ant-design/icons';

import type { Filters } from '../../types';
import { SUPPORT_TAGS, PRIORITIES } from '../constants';
import { taskPriorityIcons, taskNumberPriorityIcons } from './taskPriority';
import { useSelector, useDispatch } from 'react-redux';
import { setFilters } from '../store/settings';

import type { RootState } from '../store';

interface BoardFiltersProps {}

const BoardFilters = ({}: BoardFiltersProps) => {
    const dispatch = useDispatch();
    const settings = useSelector((state: RootState) => state.settings);
    const settingsFilters = settings.filters;
    const activeFilters = settings.filters;


    const resetFilters = () => {
        dispatch(setFilters({}));
    };

    const handleFilterArray = (value: Array<any>, key: keyof NonNullable<Filters>): void => {
        if (!value?.length) {

            const { [key]: _, ...newFilters } = activeFilters;

            dispatch(setFilters({
                ...newFilters,
            }));

            return;
        }

        dispatch(setFilters({
            ...activeFilters,
            [key]: value,
        }));
    };

    const handleFilterTag = (value: Array<string>): void => handleFilterArray(value, 'tags');
    const handleFilterPriority = (value: Array<string>): void => handleFilterArray(value, 'priority');

    const getOptionsTags = () => {
        return Object.values(SUPPORT_TAGS).map(v => ({ value: v, label: v }));
    };

    const getOptionsPriority = () => {
        return Object.values(PRIORITIES).filter(val => !isNaN(val)).map(v => ({ value: v, label: v }));
    };

    const filtersCount = Object.keys(activeFilters).length;

    const menu = {
        items: [
            {
                key: 1,
                label: <Select
                    placeholder="Теги"
                    value={activeFilters.tags}
                    allowClear
                    mode="tags"
                    style={ { minWidth: 200, maxWidth: 400, width: '100%' } }
                    options={ getOptionsTags() }
                    onChange={ handleFilterTag }
                    onClick={ (e) => e.stopPropagation() }
                />,
            },
            {
                key: 2,
                label: <Select
                    placeholder="Приоритет"
                    value={ activeFilters.priority as Array<string> | null }
                    allowClear
                    mode="multiple"
                    showSearch={ false }
                    style={ { minWidth: 200, maxWidth: 400, width: '100%' } }
                    options={ getOptionsPriority() }
                    optionRender={ (option) => settings.priorityNumberIcons ? taskNumberPriorityIcons[+option.data.value] : taskPriorityIcons[+option.data.value]}
                    labelRender={ (props) => settings.priorityNumberIcons ? taskNumberPriorityIcons[+props.value] : taskPriorityIcons[+props.value]}
                    onChange={ handleFilterPriority }
                    onClick={ (e) => e.stopPropagation() }
                />,
            },
        ],
    };

    if (filtersCount > 0) {
        menu.items.push({
            key: 3,
            label: <Button
                type="link"
                onClick={ resetFilters }
            >
                Сбросить
            </Button>,
        })
    }

    return (
        <Space>
            <Dropdown
                trigger={ [ 'click' ] }
                menu={ menu }
            >
                <Badge
                    count={filtersCount}
                    size="small"
                >
                    <Button
                        icon={filtersCount > 0
                            ? <FilterFilled style={{ fontSize: 16 }} />
                            : <FilterOutlined style={{ fontSize: 16 }} />}
                        type="text"
                    />
                </Badge>
            </Dropdown>
        </Space>
    );
};

export default BoardFilters;
